import {
  CategoryCard,
  CategoryCardProps,
} from '@ui/category/category-card.tsx';

export const CategoryGrid = ({
  items = [],
}: {
  items?: (CategoryCardProps | undefined)[];
}) => {
  return (
    <div className="flex flex-row items-center justify-between py-3">
      <ul className="grid grid-cols-3 gap-3 w-full">
        {items.map((item, index) => (
          <li key={index}>
            <CategoryCard {...item} />
          </li>
        ))}
      </ul>
    </div>
  );
};
